import { CardstackAssignment } from 'shared/api/assignment-service';

import { ActivityItem } from './ui/activity-item';
import styles from './styles.module.scss';

type ActivitiesSectionProps = {
  editingAssignment: CardstackAssignment;
};

export const ActivitiesSection = ({
  editingAssignment,
}: ActivitiesSectionProps) => {
  const assignedActivities = editingAssignment.content;

  return (
    <>
      <div className={styles.lessonTitle}>
        {assignedActivities[0].lessonTitle ?? assignedActivities[0].title}
      </div>
      {assignedActivities.map(
        (assignedActivity) =>
          assignedActivity.cardstackTitle &&
          assignedActivity.cardstackKey && (
            <ActivityItem
              key={assignedActivity.cardstackKey}
              activity={assignedActivity}
              editingAssignment={editingAssignment}
            />
          ),
      )}
    </>
  );
};
